import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  const linkCls = ({ isActive }) =>
    `text-[14px] tracking-tight font-medium transition-colors ${
      isActive ? "text-[#0dd3ce]" : "text-[#062632] hover:text-[#0dd3ce]"
    }`;
  const staticLink =
    "text-[14px] tracking-tight font-medium text-[#062632] hover:text-[#0dd3ce] transition-colors";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white border-b border-[#062632]/10 relative overflow-hidden"
    >
      {/* Subtle dot-grid texture — premium B2B detail, ~4% opacity */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle, #062632 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />
      {/* Thin cyan hairline accent at the bottom edge */}
      <div aria-hidden="true" className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#0dd3ce]/40 to-transparent" />

      <div className="relative px-6 md:px-10 lg:px-16 h-20 flex items-center justify-between gap-8">
        {/* Logo on its native white surface — no filter needed */}
        <Link
          to="/"
          data-testid="brand-link"
          aria-label="A3 Sagar Polymers home"
          className="flex items-center gap-3 group shrink-0"
        >
          <img
            data-testid="brand-logo"
            src="/brand/a3-sagar-logo-transparent.png"
            alt="A3 Sagar Polymers"
            className="h-11 w-auto transition-transform group-hover:scale-[1.04]"
          />
          <span className="hidden sm:flex flex-col leading-tight border-l border-[#062632]/15 pl-3">
            <span className="text-[14px] font-extrabold tracking-tight text-[#062632]">A3 SAGAR POLYMERS</span>
            <span className="text-[9px] uppercase tracking-[0.3em] text-[#062632]/55 font-semibold">
              Industrial Plastic Moulding · Mumbai
            </span>
          </span>
        </Link>

        {/* Nav — dark navy on white, here.com convention */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10 flex-1 justify-center">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <a href="/#capabilities" className={staticLink} data-testid="nav-capabilities">Capabilities</a>
          <a href="/#legacy" className={staticLink} data-testid="nav-legacy">Our Story</a>
          <NavLink to="/rfq" className={linkCls} data-testid="nav-rfq">RFQ</NavLink>
        </nav>

        {/* Primary CTA — dark navy pill on white; hero CTA below stays cyan */}
        <Link
          to="/rfq"
          data-testid="header-cta-rfq"
          className="hidden sm:inline-flex shrink-0 items-center bg-[#062632] text-white font-semibold px-6 py-3 text-[13px] tracking-tight rounded-full hover:bg-[#0a3845] transition-colors border border-[#062632]"
        >
          Request Quote
        </Link>
      </div>
    </header>
  );
}
